import styled from "@emotion/styled";
import { LightMode } from "@repo/skapa";
import { Variables } from "@repo/skapa";
import { differenceInDays } from "date-fns";

import { WEEK_BLOCK_HEIGHT } from "./constants";
import { getLeftPos, getRightPos, getTopPos } from "./utils";

const PositionBase = styled.div<{
  top: number;
  left?: number;
  right?: number;
}>`
  position: absolute;
  z-index: 2;
  top: ${({ top }) => top}px;
  left: ${({ left }) => left ?? 0}px;
  right: ${({ right }) => right ?? 0}px;
`;

const AllWeekLine = styled(PositionBase)`
  border-top: dashed ${LightMode.colourSemanticNegative};
`;

const TodayLine = styled(PositionBase)`
  height: ${Variables.thicknessThick};
  background-color: ${LightMode.colourSemanticNegative};
`;

const TodayDot = styled(PositionBase)`
  height: 7px;
  width: 7px;
  background-color: ${LightMode.colourSemanticNegative};
  display: inline-block;
  border-radius: 50%;
`;

export const WeekCurrentTimeLine = ({
  allDayHeight,
  startDate,
  startHour,
  endDate,
  blockWidth,
}: {
  allDayHeight: number;
  startDate: Date;
  startHour: number;
  endDate: Date;
  blockWidth: number;
}) => {
  const now = new Date();
  const dayOffset = differenceInDays(now, startDate);
  const currentHour = now.getHours();
  const currentMinute = now.getMinutes();

  const hourOffset = currentHour - startHour;
  const minuteOffset = (currentMinute * WEEK_BLOCK_HEIGHT) / 60;

  const top = getTopPos(allDayHeight, hourOffset, minuteOffset);
  const left = getLeftPos(startDate, now, blockWidth);
  const right = getRightPos(endDate, now, blockWidth);

  if (dayOffset > 6) {
    return null;
  }
  return (
    <>
      <AllWeekLine top={top} />
      <TodayLine top={top} left={left} right={right} />
      <TodayDot top={top - 2.5} left={left - 3} />
    </>
  );
};
